const entries = [
  {
    "sr": "Polo majica, chinos i lagani sako ako baš morate. Sve čisto i nenapadno. Kao čovek koji zna razliku između parfema i dezodoransa.",
    "en": "A polo shirt, chinos and a light blazer if you really must. Clean and understated. Like someone who knows the difference between perfume and deodorant."
  },
  {
    "sr": "Sako i kravata. Ako želite da budete direktor — makar sami sebi.",
    "en": "A blazer and tie. If you want to look like the CEO — even if only of yourself."
  },
  {
    "sr": "Minimalistički. Crne pantalone, kvalitetna majica, jednostavan kaput. Bois Impérial izgleda kao da bi odbio majicu sa ogromnim logom.",
    "en": "Minimalism. Black trousers, a quality T-shirt and a simple coat. Bois Impérial looks like it would reject a shirt with a giant logo."
  },
  {
    "sr": "Košulja, pantalone i sako bez kravate. Izgled čoveka koji je završio sastanak i sada ide na piće sa ljudima koje zapravo voli.",
    "en": "A shirt, trousers and a blazer without a tie. The look of someone who has finished the meeting and is now going for drinks with people they actually like."
  },
  {
    "sr": "Tamna košulja. Prva dva dugmeta mogu da ostanu pod vašom ličnom procenom i procenom osobe preko puta.",
    "en": "A dark shirt. The first two buttons are subject to your own judgement — and possibly the judgement of the person sitting opposite you."
  },
  {
    "sr": "Rolka ili mekana košulja, sako i dobre cipele. Intimnije, ne agresivno. Ovo je dejt, ne audicija za obezbeđenje.",
    "en": "A turtleneck or soft shirt, blazer and good shoes. Intimate, not aggressive. This is a date, not a security-guard audition."
  },
  {
    "sr": "Bilo šta čisto. Ozbiljno. Bela majica i farmerke su verovatno maksimum filozofije koji ovde treba primeniti.",
    "en": "Anything clean. Seriously. A white T-shirt and jeans are probably the maximum amount of philosophy required here."
  },
  {
    "sr": "Bomber jakna, majica i farmerke. Moderan casual. Ako ste upravo sišli sa električnog trotineta, još ste u temi.",
    "en": "A bomber jacket, T-shirt and jeans. Modern casual. If you have just stepped off an electric scooter, you are still on theme."
  },
  {
    "sr": "Tamnija košulja ili tanji džemper. Malo ozbiljnije od EDT-a, ali nema potrebe da vadite porodični smoking.",
    "en": "A darker shirt or a fine sweater. A little more serious than the EDT, but there is no need to dig out the family tuxedo."
  },
  {
    "sr": "Kaput, kožne cipele i košulja koja je videla peglu. Oud, duvan i koža očekuju minimum saradnje.",
    "en": "A coat, leather shoes and a shirt that has met an iron. Oud, tobacco and leather expect at least some cooperation."
  },
  {
    "sr": "Polo majica, chinos i dobar sat. Sat ne mora biti Rolex. Samo nemojte pričati svima koliko je koštao.",
    "en": "A polo shirt, chinos and a good watch. It does not have to be a Rolex. Just do not tell everyone what it cost."
  },
  {
    "sr": "Bela ili tamnoplava košulja, lagane pantalone i mokasine. Kao večera pored mora na kojoj ne slikate svaki tanjir.",
    "en": "A white or navy shirt, light trousers and loafers. Like dinner by the sea where nobody photographs every plate."
  },
  {
    "sr": "Crna majica, jakna i nešto što vam dobro stoji. Mango i vanila će odraditi ostatak flerta.",
    "en": "A black T-shirt, a jacket and something that genuinely fits you well. Mango and vanilla will handle the rest of the flirting."
  },
  {
    "sr": "Rolka, vuneni sako i tamne pantalone. Ako uz to držite čašu viskija, budite oprezni — počinjete da izgledate kao reklama.",
    "en": "A turtleneck, wool blazer and dark trousers. If you are holding a glass of whisky too, be careful — you are starting to look like an advertisement."
  },
  {
    "sr": "Farmerke, majica i lagana jakna. Vikend garderoba. Niko neće očekivati da potpišete međunarodni sporazum.",
    "en": "Jeans, a T-shirt and a light jacket. Weekend clothes. Nobody expects you to sign an international treaty."
  },
  {
    "sr": "Košulja sa zavrnutim rukavima. Dovoljno elegantno, dovoljno opušteno. Ako neko primeti podlaktice, parfem nije kriv.",
    "en": "A shirt with the sleeves rolled up. Smart enough, relaxed enough. If someone notices your forearms, the fragrance accepts no responsibility."
  },
  {
    "sr": "Sako, majica ili fina košulja i tamne farmerke. Francuska elegancija bez potrebe da nosite beretku. Molimo vas.",
    "en": "A blazer, T-shirt or fine shirt and dark jeans. French elegance without the beret. Please."
  },
  {
    "sr": "Šta god želite, samo neka izgleda namerno. Cedrat Boise može od farmerki do sakoa. Jedino pidžama zahteva ozbiljno samopouzdanje.",
    "en": "Whatever you like, as long as it looks intentional. Cedrat Boise can go from jeans to a blazer. Pyjamas simply require exceptional confidence."
  },
  {
    "sr": "Kožna ili suede jakna, tamne pantalone i čizme. Explorer je porastao i sada ima kreditnu karticu.",
    "en": "A leather or suede jacket, dark trousers and boots. Explorer grew up and now has a credit card."
  },
  {
    "sr": "Tamna rolka, jednostavan kaput i ništa napadno. Ako neko mora da priđe bliže da primeti i parfem i vas — upravo tako.",
    "en": "A dark turtleneck, simple coat and nothing loud. If someone has to come closer to notice both you and the fragrance — exactly."
  },
  {
    "sr": "Bela košulja, braon cipele, kvalitetan kaiš. Odeća odraslog čoveka koji nema potrebu da majica objašnjava njegovu ličnost.",
    "en": "A white shirt, brown shoes and a quality belt. Clothes for an adult who does not need a slogan on his chest to explain his personality."
  },
  {
    "sr": "Šta god da obučete. Ako veče krene kako treba, ionako neće dugo ostati na vama.",
    "en": "Whatever you want. If the evening goes properly, it probably will not stay on you for long anyway."
  },
  {
    "sr": "Crno. Majica, košulja ili jakna. Zove se Night Out, ne „Tuesday Morning Accounting“.",
    "en": "Black. T-shirt, shirt or jacket. It is called Night Out, not Tuesday Morning Accounting."
  },
  {
    "sr": "Majica, šorts i dobre patike. Sportski, ali ne teretana. Molimo, pustite parfem da bude jedina stvar koja je upravo izašla iz tuša.",
    "en": "A T-shirt, shorts and good sneakers. Sporty, but not gym clothes. Please let the fragrance be the only thing that has just stepped out of the shower."
  },
  {
    "sr": "Sako preko majice, tamne pantalone i dobre patike. Luksuzni casual — izraz koji postoji samo zato što ljudi odbijaju da nose odelo.",
    "en": "A blazer over a T-shirt, dark trousers and good sneakers. Luxury casual — a phrase invented because humanity refuses to wear a proper suit."
  }
];

export default entries;
